<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <!-- Profile Image -->
          <div class="col-md-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10">
              Photo de profil
            </label>
            <div class="d-flex align-items-center">
              <img
                v-if="imagepreview"
                :src="imagepreview"
                class="rounded-circle me-15"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <img
                v-else
                :src="require('@/assets/images/NoImage.png')"
                class="rounded-circle me-15"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <div>
                <input
                  ref="updateImgInput"
                  type="file"
                  accept="image/*"
                  class="d-none"
                  @change="logoSelected"
                />
                <button
                  type="button"
                  class="btn btn-primary me-2"
                  @click="() => updateImgInput?.click()"
                >
                  Choisir la photo
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="cancelImage"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>

          <!-- Nom complet -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Nom complet *</label
            >
            <input
              v-model="form.name"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="Nom complet"
              required
            />
          </div>

          <!-- CIN -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10">CIN *</label>
            <input
              v-model="form.cin"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="CIN"
              required
            />
          </div>

          <!-- CIN Pièces jointes -->
          <div class="col-md-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >CIN (Pièces jointes) *</label
            >
            <input
              type="file"
              class="form-control shadow-none rounded-0"
              accept="image/*"
              multiple
              @change="fileSelected"
            />
            <div v-if="attachments.length" class="mt-2">
              <div
                v-for="(a, i) in attachments"
                :key="i"
                class="small text-muted"
              >
                {{ a.name }} ({{ (a.size / 1024 / 1024).toFixed(1) }} MB)
              </div>
            </div>
            <div
              v-if="urls.length"
              class="d-flex mt-2 align-items-start flex-wrap"
            >
              <img
                v-for="(url, i) in urls"
                :key="i"
                :src="url"
                class="me-2 mb-2"
                style="height: 120px; object-fit: cover"
              />
              <button
                type="button"
                class="btn btn-sm btn-danger"
                @click="removeFiles"
              >
                Supprimer
              </button>
            </div>
          </div>

          <!-- Téléphone -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Numéro de téléphone *</label
            >
            <input
              v-model="form.phone"
              type="text"
              pattern="^0[0-9]{9}$"
              class="form-control shadow-none rounded-0"
              placeholder="0XXXXXXXXX"
              required
            />
          </div>

          <!-- Email -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Adresse électronique *</label
            >
            <input
              v-model="form.email"
              type="email"
              class="form-control shadow-none rounded-0"
              placeholder="exemple@email.com"
              required
            />
          </div>

          <!-- Password -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Mot de passe *</label
            >
            <input
              v-model="form.password"
              type="password"
              class="form-control shadow-none rounded-0"
              placeholder="Mot de passe"
              required
            />
          </div>

          <!-- Confirm Password -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Confirmation de mot de passe *</label
            >
            <input
              v-model="form.c_password"
              type="password"
              class="form-control shadow-none rounded-0"
              placeholder="Confirmer mot de passe"
              required
            />
          </div>

          <!-- Ville Utilisateur -->
          <div class="col-md-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Ville utilisateur *</label
            >
            <input
              v-model="form.city_user"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="Ville utilisateur"
              required
            />
          </div>

          <!-- Ville -->
          <div class="col-md-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10">Ville *</label>

            <v-select
                class="custom-select-height"
                id="statut"
                v-model="form.city"
                label="name"
                placeholder="Choisir une ville"
                :options="citiesList"
              />

            <!-- <select
              v-model="form.city"
              class="form-select shadow-none rounded-0"
              required
            >
              <option v-for="(c, i) in citiesList" :key="i" :value="c">
                {{ c.name }}
              </option>
            </select> -->
          </div>

          <!-- Adresse -->
          <div class="col-md-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Adresse *</label
            >
            <textarea
              v-model="form.adresse"
              rows="2"
              class="form-control shadow-none rounded-0"
              placeholder="Adresse complète"
              required
            ></textarea>
          </div>

          <!-- Bank, RIB, Agency, Fonction -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Nom du banque *</label
            >
            <!-- <select
              v-model="form.bank"
              class="form-select shadow-none rounded-0"
              required
            >
              <option v-for="(b, i) in bankList" :key="i" :value="b">
                {{ b.name }}
              </option>
            </select> -->

            <v-select
              class="custom-select-height"
              id="banque"
              v-model="form.bank"
              label="name"
              placeholder="Choisir une banque"
              :options="bankList"
            />
             
          </div>

          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Numéro du compte *</label
            >
            <input
              v-model="form.rib"
              type="number"
              class="form-control shadow-none rounded-0"
              minlength="24"
              maxlength="24"
              placeholder="RIB"
              required
            />
          </div>

          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10">Agence *</label>
           <!--  <select
              v-model="form.agency"
              class="form-select shadow-none rounded-0"
              required
            >
              <option v-for="(a, i) in agencyList" :key="i" :value="a">
                {{ a.name }}
              </option>
            </select> -->
            <v-select
              class="custom-select-height"
              id="agence"
              v-model="form.agency"
              label="name"
              placeholder="Choisir une agence"
              :options="agencyList"
            />
          </div>

          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Fonction *</label
            >
            <!-- <select
              v-model="form.fonction"
              class="form-select shadow-none rounded-0"
              required
            >
              <option v-for="(f, i) in functionsList" :key="i" :value="f">
                {{ f.name }}
              </option>
            </select> -->
            <v-select
              class="custom-select-height"
              id="fonction"
              v-model="form.fonction"
              label="name"
              placeholder="Choisir une fonction"
              :options="functionsList"
            />

          </div>

          <!-- Zone / Fees only if Livreur -->
          <template v-if="form.fonction?.name === 'Livreur'">
            <div class="col-md-4 mb-20">
              <label class="d-block text-black fw-semibold mb-10">Zone *</label>
              <!-- <select
                v-model="form.zone"
                class="form-select shadow-none rounded-0"
                @change="getFees(form.zone)"
              >
                <option v-for="(z, i) in zoneList" :key="i" :value="z">
                  {{ z.name }}
                </option>
              </select> -->
              <v-select
                class="custom-select-height"
                id="zone"
                v-model="form.zone"
                label="name"
                placeholder="Choisir une zone"
                :options="zoneList"
              />
            </div>

            <div class="col-md-4 mb-20">
              <label class="d-block text-black fw-semibold mb-10"
                >Frais de livraison *</label
              >
              <input
                v-model="form.livred_fees"
                type="text"
                class="form-control shadow-none rounded-0"
                placeholder="Frais de livraison"
              />
            </div>

            <div class="col-md-4 mb-20">
              <label class="d-block text-black fw-semibold mb-10"
                >Frais de refus *</label
              >
              <input
                v-model="form.refused_fees"
                type="text"
                class="form-control shadow-none rounded-0"
                placeholder="Frais de refus"
              />
            </div>
          </template>

          <!-- Submit -->
          <div
            class="col-md-12 d-flex align-items-center justify-content-between mt-20"
          >
            <button type="submit" class="btn btn-success px-4 py-2">
              Enregistrer
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm ms-2"
              ></span>
            </button>
            <button type="button" class="btn btn-link text-danger">
              Annuler
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import api from "@/utils/axios";
import { useToast, POSITION } from "vue-toastification";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
// import ImageUpload from "./ImageUpload.vue";

export default defineComponent({
  name: "AddUser",
  components: {
    // ImageUpload,
  },
  setup: () => {
    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const attachments = ref<File[]>([]);
    const urls = ref<string[]>([]);
    const loading = ref(false);

    const form = reactive({
      name: "",
      cin: "",
      phone: "",
      email: "",
      password: "",
      c_password: "",
      city_user: "",
      city: null as any,
      adresse: "",
      bank: null as any,
      rib: "",
      agency: null as any,
      fonction: null as any,
      zone: null as any,
      livred_fees: "",
      refused_fees: "",
      attachments: [] as File[],
      image: null as File | null,
    });

    // Example static lists

    interface City {
      id: number;
      name: string;
    }
    const zoneList = ref<any[]>([]);
    const functionsList = ref<any[]>([]);
    const agencyList = ref<any[]>([]);
    const bankList = ref<any[]>([]);
    const citiesList = ref<City[]>([]);
    const { showToast } = useAppToast();

    onMounted(async () => {
      try {
        const response = await api.get("/api/auth/citiesList");
        if (response && response.data) {
          citiesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // zones
      try {
        const response = await api.get("/api/auth/ListZone");
        if (response && response.data) {
          zoneList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // zones
      try {
        const response = await api.get("/api/auth/agency");
        if (response && response.data) {
          agencyList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // FunctionsList
      try {
        const response = await api.get("/api/auth/list_role");
        if (response && response.data) {
          functionsList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // FunctionsList
      try {
        const response = await api.get("/api/auth/banks");
        if (response && response.data) {
          bankList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }
    });

    const logoSelected = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];

      if (file) {
        form.image = file; // use the 'file' variable instead of re-accessing target.files
        imagepreview.value = URL.createObjectURL(file);
      }
    };

    const cancelImage = () => {
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    const fileSelected = (e: Event) => {
      const files = Array.from((e.target as HTMLInputElement).files || []);
      attachments.value = files;
      urls.value = files.map((f) => URL.createObjectURL(f));
    };

    const removeFiles = () => {
      attachments.value = [];
      urls.value = [];
    };

    const getFees = (zone: any) => {
      // fetch fees for selected zone
      console.log("Fetch fees for", zone);
    };

    const handleSubmit = async () => {
      if (form.password !== form.c_password) {
        console.error("Passwords do not match");
        showToast("Merci de verifier les mots de passe", "error");
        return;
      }

      if (
        !form.agency ||
        !form.fonction ||
        !form.phone
        // || !form.city
      ) {
        showToast("Merci de remplir tous les champ", "error");
        return;
      }

      const data = new FormData();
      data.append("agency", form.agency.id);
      data.append("type", form.fonction.name);
      data.append("role_id", form.fonction.id);
      data.append("rib", form.rib);
      data.append("bank", form.bank?.name || "");
      data.append("id_bank", form.bank?.id || "");
      data.append("adresse", form.adresse);
      data.append("city", form.city?.name || "");
      data.append("city_id", form.city?.id || "");
      data.append("city_user", form.city_user);
      data.append("zone_id", form.city?.id_zone || "");
      data.append("zone_livr", form.zone?.id || "");
      data.append("c_password", form.c_password);
      data.append("password", form.password);
      data.append("email", form.email);
      data.append("phone", form.phone);
      data.append("cin", form.cin);
      data.append("name", form.name);
      if (form.image) data.append("pic", form.image);
      data.append("livred_fees", form.livred_fees);
      data.append("refused_fees", form.refused_fees);

      for (let i = 0; i < form.attachments.length; i++) {
        data.append("attachments[]", form.attachments[i]);
      }

      try {
        console.log("Submitting form with data:", data);
        loading.value = true;
        const res = await api.post(`/api/auth/userAdd`, data, {headers: { "Content-Type": "multipart/form-data" }});
        console.log(res);

        if (res.data === "success" || res.data.success) {
          showToast("Utilisateur est bien ajouté", "success");
          router.push("/users-list");
        } else if (res.data === "not match") {
          showToast("Merci de verifier les mots de passe", "error");
        } else {
          showToast("Erreur lors de l'ajout de l'utilisateur", "error");
        }
      } catch (err) {
        console.error("Error submitting form:", err);
      } finally {
        loading.value = false;
      }
    };

    return {
      updateImgInput,
      imagepreview,
      attachments,
      urls,
      form,
      citiesList,
      bankList,
      agencyList,
      functionsList,
      zoneList,
      loading,
      logoSelected,
      cancelImage,
      fileSelected,
      removeFiles,
      getFees,
      handleSubmit,
    };
  },
});
</script>